export default __webpack_public_path__ + "static/media/image-38.7e7ef711.png";